import apiCall from "../apiService";
import { AUTH_ROUTES } from "../../utils/constants/apiRoute";
/**
 * Fetches report data for a given date range using the centralized API call utility.
 *
 * @param {string} startDate - The start date in YYYY-MM-DD format (e.g., '2025-05-15').
 * @param {string} endDate - The end date in YYYY-MM-DD format (e.g., '2025-06-16').
 * @returns {Promise<Object>} - The report data for the specified date range.
 * @throws Will throw an error if the request fails or the dates are invalid.
 * 
 * @example
 * const data = await DateRangeApi('2025-05-15', '2025-06-16');
 * console.log(data);
 * 
 * Mishra
 */
const fetchRangeReport = async (startDate, endDate) => {
  const query = `startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`;
  return await apiCall(`${AUTH_ROUTES.RANGE_REPORT_BY_QUERY_API_ENDPOINT}?${query}`, {
    method: "GET",
  });
};

export default fetchRangeReport;
